import { Component, OnInit } from '@angular/core';
import { Location  } from '@angular/common';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit(): void {
  }
  navigateToHome() {
    window.location.href = '/'
  }
}
